var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinWorkingOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 38.75,
    rx: 5,
    ry: 1.25,
    fill: "#5E656E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6237 17.1767C35.578 7.72618 27.5468 0.231435 18.116 1.36335C11.2947 2.18047 5.65711 7.69939 4.578 14.6449C4.22484 16.9221 4.34256 19.119 4.85268 21.1618C5.57863 24.082 7.27905 26.6539 9.44382 28.6967L20.0976 38.75L30.529 28.7168C33.3282 26.0243 35.2706 22.4344 35.578 18.5162C35.6107 18.0742 35.6303 17.6254 35.6237 17.17V17.1767Z",
    fill: "white",
    stroke: "#00AA44",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.201 13.5492L27.576 22.9242C28.3082 23.6564 28.3082 24.8436 27.576 25.5758C26.8437 26.308 25.6565 26.308 24.9243 25.5758L15.5493 16.2008L18.201 13.5492Z",
    fill: "#CBCED0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.142 9.39347L12.7209 13.8146C12.5989 13.9366 12.5989 14.1345 12.7209 14.2565L13.7499 16.125L15.5935 17.1291C15.7156 17.2512 15.9134 17.2512 16.0355 17.1291L19.1291 14.0355C19.2511 13.9135 19.2511 13.7156 19.1291 13.5936L17.9105 12.375C17.6122 12.0747 17.8791 11.75 17.8791 11.75L19.5817 10.0474C19.7674 9.86162 19.6549 9.54341 19.3937 9.51568L17.396 9.30369C17.3021 9.29373 17.2087 9.32673 17.142 9.39347Z",
    fill: "#93999F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.45 13.7029L28.0437 12.1092C28.2437 11.9029 28.5937 12.0029 28.6625 12.2842C28.9125 13.3217 28.6375 14.4592 27.825 15.2717C26.9605 16.1361 25.7187 16.3967 24.6283 16.0493L18.543 22.1772C18.8719 23.2745 18.5942 24.5162 17.7187 25.3655C16.9062 26.1467 15.7875 26.4155 14.7687 26.1655C14.4875 26.0967 14.3937 25.7467 14.5937 25.5467L16.1875 23.953C16.3312 23.8092 16.3312 23.578 16.1875 23.4342L15.1812 22.428C15.0375 22.2842 14.8062 22.2842 14.6625 22.428L13.0687 24.0217C12.8687 24.2279 12.5187 24.128 12.45 23.8467C12.2 22.8092 12.475 21.6717 13.2875 20.8592C14.1602 19.9864 15.4177 19.7292 16.5157 20.0918L22.5792 13.9858C22.2352 12.8807 22.5097 11.623 23.3937 10.7654C24.2062 9.98418 25.325 9.71543 26.3437 9.96543C26.625 10.0342 26.7187 10.3842 26.5187 10.5842L24.925 12.1779C24.7812 12.3217 24.7812 12.5529 24.925 12.6967L25.9312 13.7029C26.075 13.8467 26.3062 13.8467 26.45 13.7029Z",
    fill: "#93999F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7355 15.0613C10.6744 15.0003 10.6744 14.9014 10.7355 14.8404L11.1376 14.4382C11.6258 13.95 12.4172 13.95 12.9054 14.4382L15.3361 16.8689C15.8242 17.357 15.8242 18.1485 15.3361 18.6366L14.9339 19.0388C14.8729 19.0998 14.774 19.0998 14.7129 19.0388L10.7355 15.0613Z",
    fill: "#5E656E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinWorkingOff);
export default __webpack_public_path__ + "static/media/icon-pin-working-off.34aee0189fa3f6f263a784b437a601f0.svg";
export { ForwardRef as ReactComponent };